import React from 'react';
import arrowDownIcon from '../assets/icons/arrow_down.svg';
import arrowDownIconBlack from '../assets/icons/altArrowBlack.svg';

function DropDownIconTemplate({ collapse, black = false }) {
  return (
    <img
      style={{
        transform: collapse ? 'rotate(180deg)' : 'rotate(0deg)',
        maxWidth: 20,
        maxHeight: 20,
      }}
      src={black ? arrowDownIconBlack : arrowDownIcon}
      alt="arrow down"
    />
  );
}

export default DropDownIconTemplate;
